module.exports = "<div class=\"play-wrapper\" data-poster></div>\n";